setTimeout(function(){
    // Get product data from JSON
    async function getProductData(productHandle) {
        const response = await fetch('/products/' + productHandle + '.json');
        return await response.json();
    }

    // Broth Selector Elements
    const $broth = {
        selector: document.getElementById('broth-selector'),
        selected: document.querySelector('.selected-broth'),
        circle: document.querySelector('.selected-broth .circle'),
        name: document.querySelector('.selected-broth .broth-name'),
        all: document.getElementsByClassName('single-broth'),
    }

    // Product Image Elements
    const productImages = {
        allMain: document.querySelectorAll('.swiper-slide img')
   }

    // Check for the active flavor
    const checkFlavors = () => {
        const selectedFlavor = $broth.selected.getAttribute('data-flavor');
        const broths = document.getElementsByClassName('single-broth');
        for (const broth of broths) {
            const flavor = broth.getAttribute('data-flavor');
            if (flavor === selectedFlavor) {
                broth.classList.add('hover');
            } else {
                broth.classList.remove('hover');
            }
        }
    }
    checkFlavors();

    // Get the selling plan delivery schedule for the selected flavor
    function getSellingPlanSchedule() {
        const selectElement = document.querySelector('.rtx-subscription-dropdown');
        if (selectElement){
            const selectedOption = selectElement.options[selectElement.selectedIndex];
            console.log('selected', selectedOption);
            return selectedOption.innerHTML;
        }
        return '';
    }

    // Get the selected Variant amount from option-1 radio buttons
    function getSelectedVariant() {
        const radioElements = document.querySelectorAll('input[name="option-1"]');
        for (const radioElement of radioElements) {
            if (radioElement.checked) {
                return radioElement.value;
            }
        }
    }

    // Toggle active status for dropdown
    $broth.selected.addEventListener('click', function() {
        $broth.selector.classList.toggle('active');
    });

    // Refresh Yotpo Reviews
    function refreshYotpo(){
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
    }

    // Flavor Switched Event
    const flavorSwitched = new Event('flavorSwitched');

    // Select a new flavor
    for (const singleBroth of $broth.all) {
        singleBroth.addEventListener('click', function() {
            if (!singleBroth.classList.contains('hover')) {
                document.dispatchEvent(flavorSwitched);
            }
            const thisFlavor = {
                data: singleBroth.getAttribute('data-flavor'),
                name: singleBroth.getAttribute('data-flavor-string'),
                handle: singleBroth.getAttribute('data-handle'),
                productId: singleBroth.getAttribute('data-product-id'),
                description: singleBroth.getAttribute('data-product-description'),
                flavorColor: singleBroth.getAttribute('data-flavor-color'),
                shortDescription: singleBroth.getAttribute('data-short-description'),
                productImage: singleBroth.getAttribute('data-product-image'),
                productTitle: singleBroth.getAttribute('data-product-title'),
                ingredients: singleBroth.getAttribute('data-ingredients'),
                ingredients_bg: singleBroth.getAttribute('data-ingredients-bg'),
                ingredientsList: singleBroth.getAttribute('data-ingredients-list'),
                ingredientsTitle: singleBroth.getAttribute('data-ingredients-title'),
                howToMedia: singleBroth.getAttribute('data-how-to-media'),
                delayDescription: singleBroth.getAttribute('data-delay-description'),
                box2: singleBroth.getAttribute('data-2-box'),
                box4: singleBroth.getAttribute('data-4-box'),
                box6: singleBroth.getAttribute('data-6-box'),
                box2inventory: singleBroth.getAttribute('data-2-box-inventory'),
                box4inventory: singleBroth.getAttribute('data-4-box-inventory'),
                box6inventory: singleBroth.getAttribute('data-6-box-inventory'),
                box2selling: singleBroth.getAttribute('data-2-keep-selling'),
                box4selling: singleBroth.getAttribute('data-4-keep-selling'),
                box6selling: singleBroth.getAttribute('data-6-keep-selling'),
                sellingPlan2: singleBroth.getAttribute('data-selling-plan-2'),
                sellingPlan3: singleBroth.getAttribute('data-selling-plan-3'),
                sellingPlan4: singleBroth.getAttribute('data-selling-plan-4'),
                sellingPlan5: singleBroth.getAttribute('data-selling-plan-5'),
                sellingPlan6: singleBroth.getAttribute('data-selling-plan-6'),
                sellingPlan7: singleBroth.getAttribute('data-selling-plan-7'),
                sellingPlan8: singleBroth.getAttribute('data-selling-plan-8'),
            }
            const existingFlavor = {
                data: $broth.selected.getAttribute('data-flavor'),
                handle: $broth.selected.getAttribute('data-handle'),
                description: document.querySelector('.product-description__content-inner'),
                shortDescription: document.querySelector('.product__short-description'),
                productTitle: document.querySelector('.product-description__title'),
                productImage: document.querySelector('.product-description__image img'),
                ingredients: document.querySelector('.ingredients__image [data-popup-btn]'),
                ingredients_bg: document.querySelector('.ingredients__image img'),
                ingredientsTitle: document.querySelector('.ingredients__content-title'),
                ingredientsList: document.querySelector('.ingredients__list'),
                howToMedia: document.querySelector('.how-to__media'),
                delayDescription: document.querySelector('.delay')
            }
            const addToCartBtn = document.querySelector('.product__submit');
            const addToCartBtnFlavor = document.querySelector('.submit.flavor');
            console.log('thisFlavor2', thisFlavor)

            // Update the URL in address bar to match the selected flavor
            window.history.pushState({}, '', '/products/' + thisFlavor.handle);

            // Remove existing flavor
            $broth.circle.classList.remove(existingFlavor.data);
            $broth.circle.style.backgroundColor = thisFlavor.flavorColor;
            // Update the reviews widgets
            document.querySelector('.yotpo.bottomLine').setAttribute('data-product-id', thisFlavor.productId);
            document.querySelector('.yotpo-main-widget').setAttribute('data-product-id', thisFlavor.productId);

            // Add new flavor
            $broth.circle.classList.add(thisFlavor.data);
            $broth.name.classList.add(thisFlavor.data);
            $broth.selected.setAttribute('data-flavor', thisFlavor.data);
            $broth.selected.setAttribute('data-flavor-string', thisFlavor.name);
            $broth.selected.setAttribute('data-handle', thisFlavor.handle);
            $broth.name.innerHTML = thisFlavor.name;
            checkFlavors();
            existingFlavor.description.innerHTML = thisFlavor.description;
            existingFlavor.shortDescription.innerHTML = thisFlavor.shortDescription;

            // Update Product Title
            if ( thisFlavor.productTitle ) {
                existingFlavor.productTitle.innerHTML = thisFlavor.productTitle;
            }
            else {
                existingFlavor.productTitle.innerHTML = thisFlavor.name;
            }

            // Update Product Image
            if ( !thisFlavor.productImage.startsWith('Liquid error') ) {
                existingFlavor.productImage.src = thisFlavor.productImage;
            }

            // Update Ingredients Title
            if ( existingFlavor.ingredientsTitle ){
                existingFlavor.ingredientsTitle.innerHTML = thisFlavor.ingredientsTitle;
            }

            // Update Ingredients List
            if ( existingFlavor.ingredientsList ){
                existingFlavor.ingredientsList.innerHTML = thisFlavor.ingredientsList;
            }

            // Update Delay Description
            if ( existingFlavor.delayDescription ){
                existingFlavor.delayDescription.innerHTML = '<span>' + thisFlavor.delayDescription + '</span>';
            }

            // Update Ingredients Image
            if ( thisFlavor.ingredients_bg && thisFlavor.ingredients_bg.length > 0 ){
                existingFlavor.ingredients_bg.src = thisFlavor.ingredients_bg;
            }else {
                existingFlavor.ingredients_bg.src ="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_600x600.gif"
            }
            if ( thisFlavor.ingredients && thisFlavor.ingredients.length > 0 ){
                existingFlavor.ingredients.classList.remove('d-none')
                existingFlavor.ingredients.setAttribute('data-popup-content', thisFlavor.ingredients)

            }else {
                existingFlavor.ingredients.classList.add('d-none')
            }
            
            // Update How To Media
            if ( thisFlavor.howToMedia && thisFlavor.howToMedia.length > 0 ){
                existingFlavor.howToMedia.innerHTML = thisFlavor.howToMedia;
            }

            // Change Yotpo Pictues Widget Product ID
            const yotpoPicturesWidget = document.querySelector('.yotpo-pictures-widget');

            if ( thisFlavor.productId && yotpoPicturesWidget ){
                yotpoPicturesWidget.dataset.productId = thisFlavor.productId;
            }

            // Update selected Selling Plan value
            const selectedSellingPlan = getSellingPlanSchedule();

            if (document.getElementById('flavor_selector_type').value === 'Lemon Sips'){
                if ( selectedSellingPlan === 'Delivery every 4 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan2);
                }
                else if ( selectedSellingPlan === 'Delivery every 6 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan3);
                }
                else if ( selectedSellingPlan === 'Delivery every 8 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan4);
                }
                else if ( selectedSellingPlan === 'Delivery every 12 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan5);
                }
            }
            else {
                if ( selectedSellingPlan === 'Delivery every 2 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan2);
                }
                else if ( selectedSellingPlan === 'Delivery every 3 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan3);
                }
                else if ( selectedSellingPlan === 'Delivery every 4 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan4);
                }
                else if ( selectedSellingPlan === 'Delivery every 5 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan5);
                }
                else if ( selectedSellingPlan === 'Delivery every 6 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan6);
                }
                else if ( selectedSellingPlan === 'Delivery every 7 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan7);
                }
                else if ( selectedSellingPlan === 'Delivery every 8 weeks' ){
                    $broth.selected.setAttribute('data-selling-plan', thisFlavor.sellingPlan8);
                }
            }



            // Get selected variant and update
            const variantBoxes = getSelectedVariant();
            if ( variantBoxes === '2 Boxes' ){
                $broth.selected.setAttribute('data-variant-id', thisFlavor.box2);
            }
            else if ( variantBoxes === '4 Boxes' ){
                $broth.selected.setAttribute('data-variant-id', thisFlavor.box4);
            }
            else if ( variantBoxes === '6 Boxes' ){
                $broth.selected.setAttribute('data-variant-id', thisFlavor.box6);
            }

            // Check inventory for each variant, add soldout class
            let soldOut2 = false, soldOut4 = false, soldOut6 = false;
            const swatches = document.querySelector('.swatch[data-option-index="0"]'),
                swatchesWrapper = document.querySelector('.swatches-wrapper');

            if (thisFlavor.box2inventory <= 1 && thisFlavor.box2selling !== 'continue') {
                if (document.querySelector('.product-option__select li span[data-value="2 Boxes"]')) {
                    document.querySelector('.product-option__select li span[data-value="2 Boxes"]').classList.add('soldout');
                }
                soldOut2 = true;
            } else {
                if (document.querySelector('.product-option__select li span[data-value="2 Boxes"]')) {
                    document.querySelector('.product-option__select li span[data-value="2 Boxes"]').classList.remove('soldout');
                }
            }

            if (thisFlavor.box4inventory <= 1 && thisFlavor.box4selling !== 'continue') {
                if (document.querySelector('.product-option__select li span[data-value="4 Boxes"]')) {
                    document.querySelector('.product-option__select li span[data-value="4 Boxes"]').classList.add('soldout');
                }
                soldOut4 = true;
            } else {
                if (document.querySelector('.product-option__select li span[data-value="4 Boxes"]')) {
                    document.querySelector('.product-option__select li span[data-value="4 Boxes"]').classList.remove('soldout');
                }
            }

            if (thisFlavor.box6inventory <= 1 && thisFlavor.box6selling !== 'continue') {
                if (document.querySelector('.product-option__select li span[data-value="6 Boxes"]')){
                    document.querySelector('.product-option__select li span[data-value="6 Boxes"]').classList.add('soldout');
                }
                soldOut6 = true;
            } else {
                if (document.querySelector('.product-option__select li span[data-value="6 Boxes"]')){
                    document.querySelector('.product-option__select li span[data-value="6 Boxes"]').classList.remove('soldout');
                }
            }

          
            const isFlavorSoldOut = document.getElementById('flavor-is-soldout');

            // If existing page is sold out but the new flavor is not, reload the page
            if (isFlavorSoldOut){
                if (!soldOut2 || !soldOut4 || !soldOut6){
                    // Reload the page in order for the ReChaarge panel to properly load
                    window.location.reload();
                }
            }

            // Check if all variants are sold out, change CTA to "Sold Out" or "Add to Cart"
            if (soldOut2 && soldOut4 && soldOut6){

                // Reload the page in order for the Klaviyo Back-in-Stock modal iframe to load with correct product info
                window.location.reload();

                // Change CTA to "Sold Out" (Fallback)
                if ( addToCartBtn ){
                    addToCartBtn.classList.add('disabled');
                    addToCartBtn.setAttribute('disabled', 'disabled');
                    addToCartBtn.innerHTML = 'Sold Out';
                }
                if ( addToCartBtnFlavor ){
                    addToCartBtnFlavor.classList.add('disabled');
                    addToCartBtnFlavor.setAttribute('disabled', 'disabled');
                    addToCartBtnFlavor.innerHTML = 'Sold Out';
                }
            }
            else {
                if ( addToCartBtn ){
                    addToCartBtn.classList.remove('disabled');
                    addToCartBtn.removeAttribute('disabled');
                    addToCartBtn.innerHTML = 'Add to cart';

                }
                if ( addToCartBtnFlavor ){
                    addToCartBtnFlavor.classList.remove('disabled');
                    addToCartBtnFlavor.removeAttribute('disabled');
                    addToCartBtnFlavor.innerHTML = 'Add to cart';
                }

            }

            // Get product data for selected flavor and update images
            getProductData(thisFlavor.handle).then(function(result) {
                const images = result.product.images;
                for (const [index, image] of images.entries()){
                    if ( index === 0 ){
                        productImages.allMain[0].src = image.src;
                        productImages.allMain[0].srcset = image.src;
                    }
                    else if ( index === 1 ){
                        productImages.allMain[1].src = image.src;
                        productImages.allMain[1].srcset = image.src;
                    }
                    else if ( index === 2 ){
                        productImages.allMain[2].src = image.src;
                        productImages.allMain[2].srcset = image.src;
                    }
                    else if ( index === 3 ){
                        productImages.allMain[3].src = image.src;
                        productImages.allMain[3].srcset = image.src;
                    }
                    else if ( index === 4 ){
                        productImages.allMain[4].src = image.src;
                        productImages.allMain[4].srcset = image.src;
                    }
                    else if ( index === 5 ){
                        productImages.allMain[5].src = image.src;
                        productImages.allMain[5].srcset = image.src;
                    }

                }
            });

            // Update the displayed flavor name
            if (document.getElementById('flavor_selector_type')){
                if (document.getElementById('flavor_selector_type').value === 'Bone Broth'){
                    document.querySelector('.product__title').innerHTML = 'Dr. KellyAnn\'s Bone Broth - ' + thisFlavor.name;
                }
                if (document.getElementById('flavor_selector_type').value === 'Lemon Sips'){
                    if (thisFlavor.name === 'Lemon Sips'){
                        document.querySelector('.product__title').innerHTML = 'Lemon Sips';
                    }
                    else {
                        document.querySelector('.product__title').innerHTML = 'Lemon Sips - ' + thisFlavor.name;
                    }
                }
            }

            // Refresh the Yotpo review widgets
            refreshYotpo();

            // Toggle active class to highlight selected flavor
            $broth.selector.classList.toggle('active');

        });
    }

    // When Product Options Change, Check the Inventory Again
    function productOptionsChange() {
        const productOptions = document.querySelectorAll('.product-option__select li');
        const submitButton = document.querySelector('.product__submit');
        const submitFlavor = document.querySelector('.submit.flavor');
        console.log('product options change');
        for (const productOption of productOptions) {
            productOption.addEventListener('click', function() {
                if ( productOption.querySelector('span').classList.contains('soldout') ){
                    if (submitButton){
                        submitButton.classList.add('disabled');
                        submitButton.setAttribute('disabled', 'disabled');
                    }
                    if (submitFlavor){
                        submitFlavor.classList.add('disabled');
                        submitFlavor.setAttribute('disabled', 'disabled');
                    }
                    setTimeout(function(){
                        if (submitButton){
                            submitButton.innerHTML = 'Sold Out';
                        }
                        if (submitFlavor){
                            submitFlavor.innerHTML = 'Sold Out';
                        }
                    }, 6);
                }
                else {
                    if (submitButton){
                        submitButton.classList.remove('disabled');
                        submitButton.removeAttribute('disabled');
                    }
                    if (submitFlavor){
                        submitFlavor.classList.remove('disabled');
                        submitFlavor.removeAttribute('disabled');
                    }
                    setTimeout(function(){
                        if (submitButton){
                            submitButton.innerHTML = 'Add to Cart';
                        }
                        if (submitFlavor){
                            submitFlavor.innerHTML = 'Add to Cart';
                        }
                    }, 6);

                }
            });
        }
    }

    productOptionsChange();

    // Check Purchase Option for either subscription or onetime
    function getPurchaseOption() {
        const options = document.getElementsByName('purchaseOption');
        for (const option of options) {
            if (option.checked) {
                return option.value;
            }
        }
        return null;
    }

    // Update variant ID when boxes are changed
    const variantOptions = document.querySelectorAll('input[name="option-1"]');
    for (const radioElement of variantOptions) {
        radioElement.addEventListener('change', function() {
            const selectedHandle = $broth.selected.getAttribute('data-handle');

            if ( this.value === '2 Boxes'){
                $broth.selected.setAttribute('data-variant-id', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-2-box'))
            }
            else if ( this.value === '4 Boxes'){
                $broth.selected.setAttribute('data-variant-id', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-4-box'))
            }
            else if ( this.value === '6 Boxes'){
                $broth.selected.setAttribute('data-variant-id', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-6-box'))
            }
        });
    }

    // If Flavor Has Been Changed
    document.addEventListener('flavorSwitched',(e) => {
            console.log('flavor switched');
            let submitButton = document.querySelector('.product__submit'),
                submitFlavor = document.querySelector('.submit.flavor'),
                klaviyoBIS = document.querySelector('.klaviyo-bis-trigger'),
                rechargeBox = document.querySelector('.rc-widget-injection-parent');

            if (rechargeBox) rechargeBox.classList.remove('d-none');
            if (submitFlavor) submitFlavor.classList.remove('d-none');
            if (submitButton) submitButton.classList.add('d-none');
            if (klaviyoBIS) klaviyoBIS.classList.add('d-none');
            document.getElementById('flavor_selector').value = 'true';
        },
        false
    );

    // Add to Cart button for Flavor Selector PDPs Only
    if ( document.getElementById('flavor_selector') ){
        // Capture Add to Cart Button & Prevent Default
        document.querySelector('.submit.flavor').addEventListener('click', function(){

            // Check if one time purchase or has Selling Plan
            let selectedOption;
            if ( document.querySelector('#purchaseTypeOneTime:checked') ){
                selectedOption = 'onetime';
            }
            else {
                selectedOption = 'subscription';
            }

            console.log('selectedOption', selectedOption);

            const selectedHandle = $broth.selected.getAttribute('data-handle');
            const selectedSellingPlan = getSellingPlanSchedule();
            const selectedBroth = document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]');
            const masterSelect = document.querySelector('#master-select');
            const masterSelectedOption = masterSelect.options[masterSelect.selectedIndex];
            const selectedDataOption = masterSelectedOption.getAttribute('data-option-1');

            let variantId;
            if (document.getElementById('flavor_selector_type').value === 'Lemon Sips'){
                if (selectedDataOption === '1 Jar'){
                    variantId = selectedBroth.getAttribute('data-2-box');
                }
                if (selectedDataOption === '3 Jars'){
                    variantId = selectedBroth.getAttribute('data-4-box');
                }
                if (selectedDataOption === '6 Jars'){
                    variantId = selectedBroth.getAttribute('data-6-box');
                }
            }
            else {
                if (selectedDataOption === '2 Boxes'){
                    variantId = selectedBroth.getAttribute('data-2-box');
                }
                if (selectedDataOption === '4 Boxes'){
                    variantId = selectedBroth.getAttribute('data-4-box');
                }
                if (selectedDataOption === '6 Boxes'){
                    variantId = selectedBroth.getAttribute('data-6-box');
                }
            }


            if ( selectedOption === 'onetime' ){
                brothAddToCart(variantId, 1, '');
            }
            else if ( selectedOption === 'subscription' ){
                let sellingPlanId;

                console.log('selectedSellingPlan', selectedSellingPlan);

                if (document.getElementById('flavor_selector_type').value === 'Lemon Sips'){
                    if ( selectedSellingPlan === 'Delivered every 4 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-2');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 6 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-3');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 8 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-4');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 12 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-5');
                    }
                }
                else {
                    if ( selectedSellingPlan === 'Delivered every 2 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-2');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 3 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-3');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 4 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-4');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 5 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-5');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 6 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-6');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 7 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-7');
                    }
                    else if ( selectedSellingPlan === 'Delivered every 8 weeks' ){
                        sellingPlanId = selectedBroth.getAttribute('data-selling-plan-8');
                    }
                }

                brothAddToCart(variantId, 1, sellingPlanId);
            }
        });


    }



    // Add to Cart Fetch
    async function brothAddToCart(variantId, quantity, sellingPlan) {
        console.log('brothAddToCart', variantId, quantity, sellingPlan)
        let formData = {
            'items': [{
                'id': variantId,
                'quantity': quantity,
                'selling_plan': sellingPlan,
            }]
        };
        console.log('formData', formData);
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .then(data=> console.log(data))
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    // If selling plan is changed, update the selected value
    document.addEventListener('change', function(event) {
        const target = event.target;
        const sellingPlanHtml = document.querySelector('.rc-selling-plans-dropdown__select option:checked');
        if (typeof(sellingPlanHtml) != 'undefined' && sellingPlanHtml != null && target.matches('.rc-selling-plans-dropdown__select')) {
            const selectedValue = sellingPlanHtml.innerHTML;
            const selectedHandle = $broth.selected.getAttribute('data-handle');

            if ( selectedValue === 'Delivery every 2 Weeks' ){
                $broth.selected.setAttribute('data-selling-plan', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-selling-plan-2'));
            }
            else if ( selectedValue === 'Delivery every 3 Weeks' ){
                $broth.selected.setAttribute('data-selling-plan', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-selling-plan-3'));
            }
            else if ( selectedValue === 'Delivery every 4 Weeks' ){
                $broth.selected.setAttribute('data-selling-plan', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-selling-plan-4'));
            }
            else if ( selectedValue === 'Delivery every 5 Weeks' ){
                $broth.selected.setAttribute('data-selling-plan', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-selling-plan-5'));
            }
            else if ( selectedValue === 'Delivery every 6 Weeks' ){
                $broth.selected.setAttribute('data-selling-plan', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-selling-plan-6'));
            }
            else if ( selectedValue === 'Delivery every 7 Weeks' ){
                $broth.selected.setAttribute('data-selling-plan', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-selling-plan-7'));
            }
            else if ( selectedValue === 'Delivery every 8 Weeks' ){
                $broth.selected.setAttribute('data-selling-plan', document.querySelector('.single-broth[data-handle="' + selectedHandle + '"]').getAttribute('data-selling-plan-8'));
            }
        }
    });

}, 1000);